import ajax, { ExtraFetchParams } from '@ajax';

/**
 * @summary c端-记录销售分享动作
 * */
export const SaleShareRecordPost = (data: any, opt?: ExtraFetchParams) => {
  const p: any = {};
  p.data = data;
  return ajax.ajax({
    ...opt,
    method: 'POST',
    url: '/biz/v1/clue/sale_share/record',
    ...p
  });
};
